import React from 'react'
import { InputFail } from '~/Components/Form'
import * as Comp from './style'
import InputProps from '../inputProps'
import * as images from '../../data/images';
const AddCoupon = () => {
    const { inputProps } = InputProps()

    return (
        <Comp.CouponComp>
            <Comp.TextCoupon >
                <img src={images.Coupon} alt="" />
                هل لديك رمز بروموكود؟
            </Comp.TextCoupon>
            <InputFail inputProps={inputProps} placeholder='الرمز' />
        </Comp.CouponComp>
    )


}

export default AddCoupon